import React from 'react';
import { motion } from 'framer-motion';
import {
  MessageSquare, Briefcase, Calendar, GraduationCap, Trophy,
  Globe, Users, TrendingUp, Filter, Star
} from 'lucide-react';

const CategoryList = ({ categories, activeCategory, onCategoryChange }) => {
  const getCategoryIcon = (iconName) => {
    const icons = {
      Briefcase,
      Calendar,
      GraduationCap,
      Trophy,
      Globe,
      Users,
      TrendingUp,
      Star,
      MessageSquare
    };
    return icons[iconName] || MessageSquare;
  };

  const allCategory = {
    _id: 'all',
    name: 'All Posts',
    icon: 'MessageSquare',
    postCount: categories.reduce((sum, cat) => sum + (cat.postCount || 0), 0)
  };

  const categoriesWithAll = [allCategory, ...categories];

  return (
    <div className="lg:sticky lg:top-4">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 lg:p-4">
        <div className="flex items-center gap-2 mb-3">
          <div className="w-6 h-6 dynamic-site-bg rounded-lg flex items-center justify-center">
            <Filter size={14} className="text-white" />
          </div>
          <h3 className="font-semibold text-base dynamic-site-text-1">Categories</h3>
        </div>
        
        <div className="space-y-1 max-h-[46vh] overflow-y-auto overflow-x-hidden">
          {categoriesWithAll.map((category) => {
            const IconComponent = getCategoryIcon(category.icon);
            const isActive = activeCategory === category._id;
            
            return (
              <motion.button
                key={category._id}
                onClick={() => onCategoryChange(category._id)}
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                className={`w-full flex items-center gap-2 p-2 lg:p-3 rounded-lg transition-all duration-200 text-sm ${
                  isActive
                    ? 'dynamic-site-bg text-white'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                <div className={`w-6 h-6 lg:w-8 lg:h-8 rounded-lg flex items-center justify-center ${
                  isActive
                    ? 'bg-white/20'
                    : 'bg-gray-100'
                }`}>
                  <IconComponent size={14} className={isActive ? 'text-white' : 'text-gray-600'} />
                </div>
                
                <div className="flex-1 text-left">
                  <p className="font-medium">{category.name}</p>
                  {category.description && (
                    <p className={`text-xs mt-0.5 lg:block hidden ${
                      isActive ? 'text-white/80' : 'text-gray-500'
                    }`}>
                      {category.description?.split(' ').slice(0, 4).join(' ') + (category.description?.split(' ').length > 4 ? '...' : '')}
                    </p>
                  )}
                </div>
                
                <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                  isActive
                    ? 'bg-white/20 text-white'
                    : 'bg-gray-200 text-gray-600'
                }`}>
                  {category.postCount || 0}
                </span>
              </motion.button>
            );
          })}
        </div>

   
      </div>
    </div>
  );
};

export default CategoryList;
